// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__4egWY","button":"Logo_button__IdSWA","logo":"Logo_logo__vDBPO"};